import React from "react";
import { useDispatch } from "react-redux";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { FullAgencyDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { AgencyOrganizationsTable } from "@src/features/admin/pages/agencies/components/Tables/AgencyOrganizationsTable/AgencyOrganizationsTable";
import { openDrawer } from "@src/store/slices/drawers";

interface CustomersTabProps {
  agency: FullAgencyDto;
}
export const OrganizationsTab = ({ agency }: CustomersTabProps) => {
  const dispatch = useDispatch();

  return (
    <Grid
      container
      item
      direction={"column"}
      sx={{ padding: "15px" }}
      rowSpacing={2}
    >
      {agency.organizationAgencyLinks.length ? (
        <AgencyOrganizationsTable
          orgs={agency.organizationAgencyLinks}
          agency={agency}
        />
      ) : (
        <Grid item textAlign={{ textAlign: "center" }}>
          <IgTypography variant={"body2"}>
            No organizations assigned to this agency
          </IgTypography>
        </Grid>
      )}
      <Grid item textAlign={"end"}>
        <IgButton
          variant={"contained"}
          onClick={() => {
            dispatch(
              openDrawer({
                type: "addOrganizationAgencyLink",
                agency,
              })
            );
          }}
        >
          Add Organization to Agency
        </IgButton>
      </Grid>
    </Grid>
  );
};
